import React from "react";

const WorkSampleMob = () => {
  return (
    <section className="m-top-minus-50">
      <div className="container-fluid">
        <div className="wrapper">
          <h2 className="work_head text-center py-3">Our work</h2>
          <div className="h-section-mob first">
            <div className="row">
              <div className="col-3 pe-1">
                <div className="row gy-3">
                  <div className="col-lg-12">
                    <div className="card smallcard rounded-3 border-0 bg-bliss-logo d-flex justify-content-center align-items-center">
                      <img
                        loading="lazy"
                        src={require("../../images/bliss/newbliss.png")}
                        className="img-fluid blisslogo"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="card smallcard rounded-3 border-0">
                      <img
                        loading="lazy"
                        src={require("../../images/bliss/bliss_thumb2.webp")}
                        className="img-fluid object-fit-cover h-100"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card bigcard rounded-3 border-0">
                      <img
                        loading="lazy"
                        src={require("../../images/bliss/bliss_thumb_mid.webp")}
                        className="img-fluid object-fit-cover"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 ps-1">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="d-flex justify-content-between">
                      <div className="color-box bg-white"></div>
                      <div className="color-box bg-blissgreen"></div>
                      <div className="color-box bg-darkgreen"></div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="card filledcard rounded-3 border-0 mt-3">
                      <img
                        loading="lazy"
                        src={require("../../images/bliss/bliss_web4.png")}
                        className="img-fluid object-fit-cover"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="h-section-mob second mt-5">
            <div className="row">
              <div className="col-3 pe-1">
                <div className="row gy-3">
                  <div className="col-lg-12">
                    <div className="card smallcard rounded-3 border-0 bg-beeyond d-flex justify-content-center align-items-center">
                      <img
                        loading="lazy"
                        src={require("../../images/beeyond/beeyond_logo.png")}
                        className="img-fluid beeyondlogo"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="card smallcard rounded-3 border-0 bg-light">
                      <img
                        loading="lazy"
                        src={require("../../images/beeyond/beeyond_thumb2.webp")}
                        className="img-fluid object-fit-cover h-100"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-9">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card bigcard rounded-3 border-0">
                      <img
                        loading="lazy"
                        src={require("../../images/beeyond/beeyond_thumb3.webp")}
                        className="img-fluid object-fit-cover h-100"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="h-section-mob third mt-5">
            <div className="row">
              <div className="col-3 pe-1">
                <div className="row gy-3">
                  <div className="col-lg-12">
                    <div className="card smallcard rounded-3 border-0 bg-lifespaces-logo d-flex justify-content-center align-items-center">
                      <img
                        loading="lazy"
                        src={require("../../images/logos/lifespaces.png")}
                        className="img-fluid lifespaces_logo"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div
                      className="card smallcard rounded-3 border-0"
                      style={{ backgroundColor: "#46661C" }}
                    >
                      <div className="d-flex flex-row justify-content-between align-items-center gap-5">
                        <img
                          loading="lazy"
                          src={require("../../images/lifespaces/lifespaces_bag.png")}
                          className="img-fluid mt-0 mt-sm-1 mt-md-2 lifespaces-bag"
                          alt=""
                        />
                        <div className="d-flex flex-column gap-4 mt-3">
                          <div className="goti1 me-3"></div>
                          <div className="goti2 me-3"></div>
                          <div className="goti3 me-3"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card bigcard rounded-3 border-0 bg-light">
                      <img
                        loading="lazy"
                        src={require("../../images/lifespaces/lifespaces_web_thumb.webp")}
                        className="img-fluid object-fit-cover"
                        style={{ objectPosition: "top" }}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 ps-1">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card bigcard rounded-3 border-0">
                      <img
                        loading="lazy"
                        src={require("../../images/lifespaces/lifespaces_mob_thumb.webp")}
                        className="img-fluid object-fit-cover h-100"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="h-section-mob fourth mt-5">
            <div className="row">
              <div className="col-3 pe-1">
                <div className="row gy-3">
                  <div className="col-lg-12">
                    <div className="card smallcard d-flex justify-content-center rounded-3 border-0">
                      <img
                        loading="lazy"
                        src={require("../../images/swayam/swayam.png")}
                        className="img-fluid"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="card smallcard rounded-3 border-0 ">
                      <img
                        loading="lazy"
                        src={require("../../images/swayam/swayam_thumb2.webp")}
                        className="img-fluid object-fit-cover h-100 scaled"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card bigcard rounded-3 border-0 bg-light">
                      <img
                        loading="lazy"
                        src={require("../../images/swayam/swayam_thumb_3.webp")}
                        className="img-fluid object-fit-cover h-100"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3 ps-1">
                <div className="row">
                  <div className="col-12">
                    <div className="card filledcard mobcard rounded-3 border-0 overflow-hidden">
                      <img
                        loading="lazy"
                        src={require("../../images/swayam/swayam_thumb_4.webp")}
                        className="img-fluid object-fit-cover h-100"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="d-flex justify-content-between mt-3">
                      <div className="color-box-swayam bg-white"></div>
                      <div
                        className="color-box-swayam"
                        style={{ backgroundColor: "#AAABAD" }}
                      ></div>
                      <div
                        className="color-box-swayam"
                        style={{ backgroundColor: "#FD3E40" }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WorkSampleMob;
